/**
 * @ Author: Your name
 * @ Create Time: 2019-06-15 00:04:13
 * @ Modified by: Your name
 * @ Modified time: 2019-08-06 15:02:10
 * @ Description: 获取权限列表
 */
import axios from 'axios'
import routes from '../router'
import { GETMENULIST } from '../api'
// eslint-disable-next-line
import { Message } from 'element-ui'

const getMenUrl = GETMENULIST.GETMENU

// eslint-disable-next-line import/prefer-default-export
export async function getAllMenuList() {
  const result = await new Promise((resolve, reject) => {
    axios.post(getMenUrl)
      .then(res => {
        if (res.data) {
          if (res.data.data.length === 0) {
            // 当前账号无权登录后台管理系统，请联系管理员
            Message.error({
              title: '错误',
              message: '当前账号无权登录后台管理系统，请联系管理员'
            })
            return
          }
          // 筛选去除 “开箱日志”， “柜门管理”
          const permissionList = res.data.data.map(item => {
            if (item.id !== '4' && item.id !== '5') {
              return item.id
            }
            return ''
          })
          const arr = [...routes.slice(1)[1].children]
          const menu = arr.filter(item => permissionList.includes(item.details.permissionId))
          resolve(menu)
        }
      })
      .catch(err => {
        console.log(err)
        reject()
      })
  })
  return result
}
